import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import LiveTracking from "./pages/LiveTracking";
import History from "./pages/History";
import Emergency from "./pages/Emergency";
import Alerts from "./pages/Alerts";
import Vehicles from "./pages/Vehicles";
import Drivers from "./pages/Drivers";
import Devices from "./pages/Devices";
import DeviceHealth from "./pages/DeviceHealth";
import Commands from "./pages/Commands";
import Firmware from "./pages/Firmware";
import Sims from "./pages/Sims";
import Installations from "./pages/Installations";
import Certificates from "./pages/Certificates";
import GovPush from "./pages/GovPush";
import Dealers from "./pages/Dealers";
import Geofences from "./pages/Geofences";
import Renewals from "./pages/Renewals";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Audit from "./pages/Audit";
import DeviceGateway from "./pages/DeviceGateway";
import RoutesPage from "./pages/RoutesPage";
import ReportSchedule from "./pages/ReportSchedule";
import AlertRules from "./pages/AlertRules";
import Pois from "./pages/Pois";
import AddDevice from "./pages/AddDevice";
import RawData from "./pages/RawData";
import GroupManager from "./pages/GroupManager";
import Customers from "./pages/Customers";
import ActivationLog from "./pages/ActivationLog";
import DeploymentGuide from "./pages/DeploymentGuide";
import Graphics from "./pages/Graphics";
import Maintenance from "./pages/Maintenance";
import Settings from "./pages/Settings";
import LiveMonitor from "./pages/LiveMonitor";
function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="tracking" element={<LiveTracking />} />
              <Route path="history" element={<History />} />
              <Route path="emergency" element={<Emergency />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="alert-rules" element={<AlertRules />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="drivers" element={<Drivers />} />
              <Route path="geofences" element={<Geofences />} />
              <Route path="devices" element={<Devices />} />
              <Route path="device-health" element={<DeviceHealth />} />
              <Route path="commands" element={<Commands />} />
              <Route path="firmware" element={<Firmware />} />
              <Route path="add-device" element={<AddDevice />} />
              <Route path="raw-data" element={<RawData />} />
              <Route path="groups" element={<GroupManager />} />
              <Route path="customers" element={<Customers />} />
              <Route path="activation-log" element={<ActivationLog />} />
              <Route path="deployment" element={<DeploymentGuide />} />
              <Route path="graphics" element={<Graphics />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="settings" element={<Settings />} />
              <Route path="gateway" element={<DeviceGateway />} />
              <Route path="live-monitor" element={<LiveMonitor />} />
              <Route path="routes" element={<RoutesPage />} />
              <Route path="pois" element={<Pois />} />
              <Route path="report-schedule" element={<ReportSchedule />} />
              <Route path="installations" element={<Installations />} />
              <Route path="certificates" element={<Certificates />} />
              <Route path="gov-push" element={<GovPush />} />
              <Route path="sims" element={<Sims />} />
              <Route path="dealers" element={<Dealers />} />
              <Route path="renewals" element={<Renewals />} />
              <Route path="reports" element={<Reports />} />
              <Route path="users" element={<Users />} />
              <Route path="audit" element={<Audit />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
